import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field, ErrorMessage } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import { store } from "../../../App";
import { GetDetails, LabelHeader, ModuleHeaderTitle } from "../../utils/commonFunctions";
import { FaBook, FaCalendarAlt, FaIdCardAlt } from 'react-icons/fa'; // Importing icons for better visual cues

function Jregister() {
  const history = useHistory();
  const [tableenable, settableenable] = useState(false);
  const [tableData, settabledata] = useState();
  const [headssubheads, setheadssubheads] = useState();
  const [distList, setDistList] = useState();

  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });
  }, []);
  const todayDate = new Date();

  let year = todayDate.getUTCFullYear();

  let month = todayDate.getMonth() + 1;

  let tDate = todayDate.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (tDate < 10) {
    tDate = "0" + tDate;
  }

  const maxDate = year + "-" + month + "-" + tDate;
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;

  const CustomDateComponent = (props) => (
    <input
      className="my-custom-input"
      type="date"
      maxDate={maxDate}
      {...props}
    />
  );

  const formik = useFormik({
    initialValues: {
      fromDate: firstDayOfMonth,
      toDate: today.toISOString().substr(0, 10),
      district: ""
    },
    validate: (values) => {
      const errors = {};

      if (!values.district) {
        errors.district = "District is required";
      }
      if (!values.fromDate) {
        errors.fromDate = "From Date is required";
      }
      if (!values.toDate) {
        errors.toDate = "To Date is required";
      }
      if (values.fromDate && values.toDate && values.fromDate > values.toDate) {
        errors.toDate = "To Date must be greater than From Date";
      }
      return errors;
    },

    onSubmit: (values) => {
      let params = {
        fromDate: moment(values.fromDate).format("DD/MM/YYYY"),
        toDate: moment(values.toDate).format("DD/MM/YYYY"),
        district: values.district
      };
      store.dispatch({ type: "SHOW_SPINNER" });

      HousingService.GetJournalRegister_Report(params).then((res) => {
        settabledata(res.data);
        const paymentReceiptIds = res.data.map((item) => item.payment_receipt_id);
        const uniquePaymentIdsSet = new Set(paymentReceiptIds);
        const uniquePaymentIdsArray = Array.from(uniquePaymentIdsSet);
        const promises = uniquePaymentIdsArray.map((paymentID) => {
          let param1 = { payment_receipt_id: paymentID };
          return HousingService.getPaymentDataForReceiptHeads(param1);
        });
        Promise.all(promises)
          .then((results) => {
            const combineData = results.reduce((acc, curr) => {
              const extractedData = curr.data.map((item) => ({
                headname: item.headname,
                subheadname: item.subheadname,
                debit: item.debit,
                credit: item.credit,
                payment_receipt_id: item.payment_receipt_id
              }));
              return acc.concat(extractedData);
            }, []);
            setheadssubheads(combineData);
          })
          .catch((error) => {
            console.error("Error", error);
          })
          .finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
            settableenable(true);
          });
      });
    }
  });
  const getUniquePaymentIds = () => {
    const paymentIds = tableData?.map((item) => item.payment_receipt_id);
    return [...new Set(paymentIds)];
  };

  return (
    <>
      <style>
        {`
          .journal-entry-card {
            background-color: #f8f9fa; /* Light gray background */
            border-radius: 10px;
            padding: 20px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s;
            border: 1px solid #dee2e6; /* Light border */
          }

          .journal-entry-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 15px rgba(0, 123, 255, 0.2);
          }
          .info-icon {
            color: #008080; /* Vibrant blue for icons */
            font-size: 1.2rem;
            margin-right: 8px;
          }
          .journal-table thead th {
            background-color: #008080; /* Bright blue header */
            color: #fff;
            border-color: #008080;
          }
          .journal-table tfoot td {
            font-weight: bold;
          }
          /* Added a darker border color to make it more visible */
          .journal-table td, .journal-table th {
            border: 10px solid #008080; 
          }
        `}
      </style>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <ModuleHeaderTitle title="Journal Register" />
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#008080", borderColor: "#008080", color: "#fff" }} type="reset" onClick={() => history.goBack()} >
              Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="From Date" />
                <Field
                  name="fromDate"
                  className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"}
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  as={CustomDateComponent}
                  max={maxDate}
                />
                <ErrorMessage name="fromDate" className="text-error" component="div" />
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="To Date" />
                <Field
                  name="toDate"
                  className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"}
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  as={CustomDateComponent}
                  max={maxDate}
                />
                <ErrorMessage name="toDate" className="text-error" component="div" />
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="District name" />
                <Field component="select" name="district" className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} >
                  {formik.touched.district && formik.errors.district ? (<div className="invalid-feedback"> {formik.errors.district} </div>) : null}
                  <option value="">Select</option>
                  {distList}
                </Field>
                <ErrorMessage name="district" className="text-error" component="div" />
              </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>
            &nbsp;
            {/* Start of updated UI section */}
            <OFMSUI.Row className="journal-report-container mt-4">
              {tableenable && (
                <>
                  <div className="report-header text-center my-4">
                    <h5 className="mb-0">Journal Register Report</h5>
                    <p className="">Between {moment(formik.values.fromDate).format("DD-MM-YYYY")} and {moment(formik.values.toDate).format("DD-MM-YYYY")}</p>
                    <hr />
                  </div>

                  <div className="journal-list-wrapper">
                    {getUniquePaymentIds().length > 0 ? (
                      getUniquePaymentIds().map((paymentId, index) => {
                        const journalEntry = tableData.find((item) => item.payment_receipt_id === paymentId);
                        const relatedSubheads = headssubheads.filter((subhead) => subhead.payment_receipt_id === paymentId);
                        const totalCredit = relatedSubheads.reduce((total, subhead) => total + (subhead.credit || 0), 0);
                        const totalDebit = relatedSubheads.reduce((total, subhead) => total + (subhead.debit || 0), 0);

                        return (
                          <div key={index} className="journal-entry-card mb-4">
                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                              <div className="d-flex align-items-center me-4 mb-2 mb-md-0">
                                <span className="info-icon"><FaBook /></span>
                                <span className="fw-bold me-2">Sno: {index + 1} |</span>
                                <span className="fw-bold">Journal Voucher No: {journalEntry?.vid}</span>
                              </div>
                              <div className="d-flex flex-wrap">
                                <div className="d-flex align-items-center me-4 mb-2 mb-md-0">
                                  <span className="info-icon"><FaIdCardAlt /></span>
                                  <span className="fw-bold">Payment Receipt ID: {paymentId}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                  <span className="info-icon"><FaCalendarAlt /></span>
                                  <span className="fw-bold">Date: {journalEntry?.to_char}</span>
                                </div>
                              </div>
                            </div>

                            <Table striped bordered responsive 
                            className="journal-table" 
                            >
                              <thead 
                              className="table-dark" 
                              >
                                <tr>
                                  <th>Heads and Subheads</th>
                                  <th className="text-end">Credit</th>
                                  <th className="text-end">Debit</th>
                                </tr>
                              </thead>
                              <tbody>
                                {relatedSubheads.map((subhead, subIndex) => (
                                  <tr key={subIndex}>
                                    <td>{subhead.headname} - {subhead.subheadname}</td>
                                    <td className="text-end">{subhead.credit || 0}</td>
                                    <td className="text-end">{subhead.debit || 0}</td>
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr className="fw-bold">
                                  <td className="text-end">Total Amount (in Rs)</td>
                                  <td className="text-end text-success">{totalCredit}</td>
                                  <td className="text-end text-danger">{totalDebit}</td>
                                </tr>
                              </tfoot>
                            </Table>

                            <div className="mt-3">
                              <p className="mb-0 fw-bold text-muted">Description:</p>
                              <p className="fst-italic">{journalEntry?.description}</p>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center my-5 p-5 border rounded bg-white">
                        <h6 className="text-muted">No data found</h6>
                      </div>
                    )}
                  </div>
                </>
              )}
            </OFMSUI.Row>
            {/* End of updated UI section */}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}

export default Jregister;
